import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { CustomRoute, routeList } from '../../app.routes'
import { Profile } from '../../models/users.interface'
import { Permision } from '../../models/group.interface'

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    private paginationLimit = new BehaviorSubject<number>(10)
    paginationLimit$ = this.paginationLimit.asObservable()
    private _opened$ = new BehaviorSubject<boolean>(true)
    readonly opened$: Observable<boolean> = this._opened$.asObservable()
    private search = new BehaviorSubject<string | null>(null)
    search$ = this.search.asObservable()
    private showSearch = new BehaviorSubject(true)
    showSearch$ = this.showSearch.asObservable()
    private isOpen = new BehaviorSubject<boolean>(false)
    readonly isOpen$ = this.isOpen.asObservable()

    private navLinks = new BehaviorSubject<CustomRoute[]>(routeList)
    navLinks$ = this.navLinks.asObservable()

    private showMenu = new BehaviorSubject<boolean>(true)
    readonly showMenu$ = this.showMenu.asObservable()

    constructor() {}

    setPaginationLimit(qty: number) {
        this.paginationLimit.next(qty)
    }

    toggle(): void {
        this.isOpen.next(!this.isOpen.value)
    }

    open(): void {
        this.isOpen.next(true)
    }

    close(): void {
        this.isOpen.next(false)
    }

    setIsOpen(value: boolean): void {
        this.isOpen.next(value)
    }

    setShowMenu(value: boolean): void {
        this.showMenu.next(value)
    }

    setSearch(text: string | null) {
        this.search.next(text)
    }

    setShowSearch(value: boolean) {
        this.showSearch.next(value)
    }

    onToggle(value: boolean) {
        this.isOpen.next(value)
    }

    setNavLinks(routes: CustomRoute[]) {
        this.navLinks.next(routes)
    }

    genMenuLinks(user: Profile | null) {
        const routes = routeList
        if (user && user.is_superuser) {
            const allRoutes = routes.filter((el) => el.data.isModule)
            return this.setNavLinks(allRoutes)
        }
        if (user) {
            const userPermisions = user.permisions
            const groupPermisions = user.role_group.flatMap(
                (group) => group.permisions
            )
            //revove duplicate records
            const mergePermisons = new Set(
                [...userPermisions, ...groupPermisions].map((e) =>
                    JSON.stringify(e)
                )
            )
            const permisions = Array.from(mergePermisons).map((e) =>
                JSON.parse(e)
            ) as Permision[]
            const userRoutes = routes.filter((route) => {
                if (route.data.public && route.data.isModule) {
                    return true
                }
                return permisions.some(
                    (el) => el.path === `/${route.path}` && route.data.isModule
                )
            })
            return this.setNavLinks(userRoutes)
        }
        const publicRoutes = routes.filter(
            (route) => route.data.public && route.data.isModule
        )
        return this.setNavLinks(publicRoutes)
    }
}
